import { WorkModel } from '@Entities/work/work'
import { WorksFromUpload } from '@Entities/work/works-from-upload'

export const CLEAR_WORK_DRAFT = {
    title: '',
    createdDate: '2020-12-12T00:00:00Z',
    duration: null,
    languageCode: null,
    copyrightOfficeNumber: null,
    copyrightOfficeDate: null,
    firstUseRefusalIndicator: null,
    rightsholderProprietaryId: null,
    iswc: null,
    alternativeTitles: [],
    originalPublishers: [],
    writers: [],
    recordings: [],
    matchedRecordings: {
        count: 0,
        recordings: [],
    },
    isComplete: false,
    errors: [],
    updateDate: null,
    totalKnownShares: 0,
    lastUpdated: '',
    registrationHistoryStatus: null,
    registrationHistoryIndicator: null,
    parent: null,
    registrationHistoryDate: null,
    propertyId: null,
} as const satisfies WorkModel

export const CLEAR_WORKS_FROM_UPLOAD: WorksFromUpload = {
    complete: [],
    error: [],
    completeCount: 0,
    count: 0,
    errorCount: 0,
    isComplete: false,
    fileId: 0,
}
